<template>
  <div>
    <v-row class="mt-4 pb-1" align="center" no-gutters>
      <h4 class="checkout-h4 accent--text">
        {{ $t("finished.billet.payTheBill") }}
        {{ finalDetails ? finalDetails.billet_due : "" }}
      </h4>
      <v-spacer></v-spacer>
      <v-icon class="mr-2" color="atention">mdi-alert-circle-outline</v-icon>
      <h4 class="atention--text checkout-h4 mt-1">
        {{ $t("finished.billet.pendingPayment") }}
      </h4>
    </v-row>
    <p class="grey--text checkout-h5">
      {{ $t("finished.billet.threeDays") }}
    </p>
    <div>
      <v-row no-gutters align="center">
        <v-col class="pr-2">
          <p class="billet-box js-emaillink ma-0 checkout-h4">
            {{ finalDetails ? finalDetails.billet_barcode : "" }}
          </p>
        </v-col>
        <v-btn
          rounded
          depressed
          class="normal-text mr-1"
          color="primary"
          dark
          @click.native="copyCode"
          >{{ copyBtn }}</v-btn
        >
        <v-btn
          rounded
          depressed
          class="normal-text ml-0 mr-0"
          color="primary"
          dark
          outlined
          @click="openTicket"
          >{{ $t("finished.billet.seeBillet") }}</v-btn
        >
      </v-row>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  created() {
    this.copyBtn = "Copiar";
  },
  data() {
    return {
      copyBtn: "Copiar",
    };
  },
  computed: {
    ...mapGetters(["finalDetails"]),
  },
  methods: {
    copyCode() {
      const selection = window.getSelection();
      const emailLink = document.querySelector(".js-emaillink");

      selection.removeAllRanges();
      const range = document.createRange();
      range.selectNode(emailLink);
      selection.addRange(range);

      try {
        document.execCommand("copy");
        this.copyBtn = "Copiado";
        this.$toasted.show("Copiado!", {
          theme: "outline",
          position: "top-center",
          className: "bt-toast",
          duration: 3000,
        });
      } catch (err) {
        this.$toasted.show("Erro ao copiar código de barras", {
          theme: "outline",
          position: "top-center",
          className: "bt-toast",
          duration: 3000,
        });
      }

      selection.removeAllRanges();
    },
    openTicket() {
      window.open(this.finalDetails.billet_url);
    },
  },
};
</script>

<style scoped>
.bt-toast {
  background-color: #d33724;
}
.billet-box {
  background: #e3eef9;
  border-radius: 8px;
  padding: 12px;
  height: 40px;
}
</style>
